import React, { useState, useEffect } from 'react'
import { Button, Modal, Form, Input, Select } from 'antd';
import '../../../App.css'

function CommitteeModal({ info, onSubmit, onDelete, open, setOpen }) {
    const [form] = Form.useForm();
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        if (info.name) {
            setOpen(true)
        }
    }, [info])

    useEffect(() => {
        form.setFieldsValue(info)
    }, [info, form])

    const showModal = () => {
        setIsDisabled(false)
        form.setFieldsValue({
            id: new Date().getTime(),
            chamber: 1,
            name: null,
            sessionId: 1031
        })
        setOpen(true);
    };

    const handleCancel = () => {
        setOpen(false);
    };

    const onFinish = (data) => {
        onSubmit(data);
    };

    const deleteCommittee = () => {
        onDelete(form.getFieldsValue());
    };

    return (
        <>
            <Button type="primary" onClick={showModal}>
                New Entry
            </Button>
            <Modal
                open={open}
                title={'Edit Committee'}
                onCancel={handleCancel}
                width={750}
                footer={null}
                maskClosable={false}
            >
                <div>
                    <Form
                        layout={'horizontal'}
                        form={form}
                        labelCol={{ span: 5 }}
                        wrapperCol={{ span: 20 }}
                        style={{
                            maxWidth: 700,
                        }}
                        onFinish={onFinish}
                    >
                        <Form.Item label="ID" name='id'>
                            <Input disabled={true} />
                        </Form.Item>
                        <Form.Item label="Chamber" name='chamber'>
                            <Select
                                options={[
                                    { value: 1, label: 'House' },
                                    { value: 2, label: 'Senate' },
                                ]}
                            />
                        </Form.Item>
                        <Form.Item label="Name" name='name'>
                            <Input />
                        </Form.Item>
                        <Form.Item style={{ marginLeft: 160 }}>
                            <Button type='primary' htmlType='submit' style={{ width: 200 }}>
                                Save
                            </Button>
                            <Button danger onClick={deleteCommittee} style={{ marginLeft: 10, width: 200 }}>
                                Delete
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    );
}

export default CommitteeModal

